import { useState } from "react"

import SectionHead from "./SectionHead"

import {ImQuotesLeft} from 'react-icons/im'
import Card from '../UI/Card'
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from 'react-icons/io';
import {  testimonials  } from '../data'  


function Testmniol() {
  const [testimonial, setTestimonial] = useState(testimonials[0]);

  const prevTestimonial = () => {
    const currentIndex = testimonials.indexOf(testimonial);
    const newIndex = (currentIndex + 1) % testimonials.length;
    setTestimonial(testimonials[newIndex]);
  };

  const nextTestimonial = () => {
    const currentIndex = testimonials.indexOf(testimonial);
    const newIndex = (currentIndex - 1 + testimonials.length) % testimonials.length;
    setTestimonial(testimonials[newIndex]);
  };

  return (
    <section className="testimonials">
      <div className="container testimonials__Container">
        <SectionHead icon={<ImQuotesLeft />} title="Testimonials" className="testimioal_head" />
        <Card className="testiomials">
          <div className="testimials_avat">
            <img src={testimonial.avatar} alt={testimonial.name} />
          </div>
          <p className="testimionail_quote">{`"${testimonial.quote}"`}</p>
          <h5>{testimonial.name}</h5>
          <small className="testmiol_titl">{testimonial.job}</small>
        </Card>
        <div className="testmnial_btn-container">
          <button className="testimniol_btn" onClick={prevTestimonial}>
            <IoIosArrowDropleftCircle />
          </button>
          <button className="testimniol_btn" onClick={nextTestimonial}>
            <IoIosArrowDroprightCircle />
          </button>
        </div>
      </div>
    </section>
  );
}



export default Testmniol
